import { postObjectJson } from '../utility/request';
export const fetchVehicleFluids = (merchantId, vin) => postObjectJson(`/parts-tech/fluids/summary/${merchantId}`, { vin });
